import { createFileRoute, redirect } from '@tanstack/react-router'
import { Signup } from '@/components/signup'
import { z } from "zod";
import { isAuthenticated } from "@/auth";

const fallback = '/organization' as const

export const Route = createFileRoute('/signup')({
  component: Signup,
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
    installSensorKitSerialNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (authenticated) {
      throw redirect({ to: search.redirect || fallback })
    }
  },
})
